import colors from '../../../../../config/colors'

export enum EarningsWidgetCategory {
  Eps,
  EpsGaap,
  Revenue,
}

export const EARNINGS_WIDGET_LABELS: Record<EarningsWidgetCategory, string> = {
  [EarningsWidgetCategory.Eps]: 'EPS Performance and Forecast',
  [EarningsWidgetCategory.EpsGaap]: 'GAAP EPS Performance and Forecast',
  [EarningsWidgetCategory.Revenue]: 'Revenue Performance and Forecast',
}

export const BAR_WIDTH = 72
export const CHART_HEIGHT = 250
export const LABELS_WIDTH = 28
export const LABELS_MARGIN = 22
export const BAR_WIDTH_NARROW = 52
export const BAR_GAP = 16
export const EXTRA_WIDTH = 44
export const CHART_MARGINS = { top: 2, right: 0, bottom: 0, left: 0 }
export const TICK_STYLE = { fontSize: 10, fontWeight: 500, textAnchor: 'end' }
export const TOOLTIP_WRAPPER_STYLE = { outline: 'none', zIndex: 10 }
export const CURSOR_STYLE = {
  border: 0,
  stroke: 0,
  fill: FinvizSettings.hasDarkTheme ? colors.gray[700] : colors.gray[50],
  opacity: 0.65,
}
export const TRANSPARENT_CURSOR = { opacity: 0 }
